import React, { useEffect, useState } from 'react'
import Button from 'components/controls/button'
import { localizedTranslate } from 'assets/localization'
import { connect } from 'react-redux'
import { axiosInstance } from 'network/apis'
import { Spinner } from '@blueprintjs/core'


import 'less/unsubscribe.less'


function mapStateToProps(state) {
  return {
    t: localizedTranslate('en', state.translations.en_us)
  }
}

const UnSubscribe = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [spinnerLoading, setSpinnerLoading] = useState(true)
  const [email, setEmail] = useState("")
  // QUAL-2135: a rejected link has nothing to confirm, so the Yes button is hidden rather than
  // left clickable to produce a second failure.
  const [linkInvalid, setLinkInvalid] = useState(false)
  const userId = props.match.params.userId
  // QUAL-2135: the emailed link carries a signed token proving this link belongs to the
  // recipient (?t=...). The page only forwards it - it never signs or verifies anything, and
  // the HMAC secret exists solely in Lambda. Putting that secret in this app's .env would
  // ship it in the JS bundle to every visitor and make forged tokens trivial.
  // The token is required - there is no grace period, so a link sent before this shipped is
  // rejected with a 403 and handled below. See qual-scheduler src/security/unsubscribe-request.js.
  const unsubscribeToken = new URLSearchParams(props.location ? props.location.search : '').get('t')
  const tokenQuery = unsubscribeToken ? `?t=${encodeURIComponent(unsubscribeToken)}` : ''

  async function fetchUserEmail() {

    try {
      const result = await axiosInstance.get(`user/get-email/${userId}${tokenQuery}`, { handlerEnabled: false })
      setEmail(result.data.email)
      setSpinnerLoading(false)
    } catch (e) {
      // QUAL-2135: a 403 means the link is unsigned, altered or expired - a different problem
      // from the API being down, and the recipient can fix it themselves by using their latest
      // email, so say so instead of showing a generic failure.
      const isInvalidLink = e && e.response && e.response.status === 403
      const message = props.t(isInvalidLink ? 'unsubscribe.link.invalid' : 'unsubscribe.error.getting.email')
      setLinkInvalid(isInvalidLink)
      setEmail(message)
      console.log("an error occured ", e)
      setSpinnerLoading(false)
      props.showSnackbarMessageError(message)
      props.hideSnackbarMessage()
    }
  }

  useEffect(() => {
    setSpinnerLoading(true)
    console.log("userId : ", userId)
    fetchUserEmail()
  }, [])

  const handleValidation = async () => {
    try {
      setIsLoading(true)
      let payload = {
        "allowContactByEmail": "0"
      }
      await axiosInstance.post(`unsubscribe/unsubscribe-user/${userId}${tokenQuery}`, payload, { handlerEnabled: true })
      setIsLoading(false)
      props.history.push('/unsubscribe/success')
    } catch (e) {
      setIsLoading(false)
      console.log("an error occured ", e)
      const isInvalidLink = e && e.response && e.response.status === 403
      props.showSnackbarMessageError(props.t(isInvalidLink ? 'unsubscribe.link.invalid' : 'unsubscribe.action.error'))
      props.hideSnackbarMessage()
    }
  }

  return (
    <div >
      <div className="separator"></div>
      <div className='main-apollo-logo' />
      <div className="main-unsubscribe">
        <div className="main-unsubscribe-right">
          <div className="main-unsubscribe-right-container">
            <div className="password">
              <div class="unsusbscribe-text">
                {props.t('unsubscribe.welcome.message')}
              </div>
              <br />
              {spinnerLoading ? <Spinner intent="primary" /> : <div class="unsusbscribe-email">
                {email}
              </div>}
            </div>
            {!linkInvalid && <div className={isLoading ? 'unsubscribe-button-loading' : 'unsubscribe-button'}>
              <Button
                className="unsubscribe"
                onClick={handleValidation}
                disabled={spinnerLoading}
                isLoading={isLoading}
              > Yes
                <i className="spin-me im-arrow-right2" />
              </Button>
            </div>}
          </div>
        </div>
        <div className="main-unsubscribe-left">
          <div className="unsubscribe-logo-container" >
            <div className="i-wrap">
              <i className="im-paper-plane"></i>
            </div>
            <span>Unsubscribe</span>
          </div>
        </div>
      </div>
      <div className="footer" >
        <div className="footer-info"></div>
        <div className="footer-line"></div>
        <span >{props.t("appolo.rights")}</span>
      </div>
    </div>
  )
}

const mapDispatch = {
  showSnackbarMessageError: message => ({
    type: 'SHOW_MESSAGE',
    payload: {
      message: message,
      className: 'copy-screeners-snackbar',
    },
  }),
  hideSnackbarMessage: () => ({ type: 'HIDE_MESSAGE' })
}

export default connect(mapStateToProps, mapDispatch, null)(UnSubscribe)
